const DeviceList = () => import('Views/device/device-list');
const DeviceAddEdit = () => import('Views/device/device-addEdit');
const DeviceDetail = () => import('Views/device/device-detail');
const DeviceAlarm = () => import('Views/device/device-alarm');
const DeviceMchAlarm = () => import('Views/device/device-alarm-multichannel');
const DeviceBatchAlarm = () => import('Views/device/device-batch-alarm');
const DeviceBatchAssign = () => import('Views/device/device-batch-assign');
const DeviceSxGatewayList = () => import('Views/device/device-sx-gateway-list');
const DeviceSxGatewayDetail = () => import('Views/device/device-sx-gateway-detail');
const DeviceServiceTerm = () => import('Views/device/device-service-term');
const DeviceTableList = () => import('Views/device/device-table-list');
const DeviceServiceTermLog = () => import('Views/device/device-service-term-log');
const MonitorDeviceList = () => import('Views/monitorDevice/monitor-device-list');
const DeviceAutotest = () => import('Views/transport/device-autotest');

export default[
  { path: '/device-list', component: DeviceList },
  { path: '/device-add', component: DeviceAddEdit },
  { path: '/device-edit/:id', component: DeviceAddEdit },
  { path: '/device-detail/:id', component: DeviceDetail },
  { path: '/device-alarm/:id', component: DeviceAlarm },
  { path: '/device-alarm-multichannel/:id', component: DeviceMchAlarm },
  { path: '/device-batch-alarm', component: DeviceBatchAlarm },
  { path: '/device-batch-assign', component: DeviceBatchAssign },
  { path: '/device-sx-gateway-list', component: DeviceSxGatewayList },
  { path: '/device-sx-gateway-detail/:id', component: DeviceSxGatewayDetail },
  { path: '/device-service-term', component: DeviceServiceTerm },
  { path: '/device-table-list', component: DeviceTableList },
  { path: '/device-service-term-log/:id', component: DeviceServiceTermLog },
  { path: '/monitor-device-list', component: MonitorDeviceList },
  { path: '/device-autotest', component: DeviceAutotest },
];



// WEBPACK FOOTER //
// ./src/router/device.js